// extracted by mini-css-extract-plugin
export var checkbox = "_9f-0";
export var circle = "_9f-3";
export var horizontalContainer = "_9f-7";
export var sm = "_9f-5";
export var switch0 = "_9f-2";
export var switchDisabled = "_9f-8";
export var switchEnabled = "_9f-1";
export var textSwitchContainer = "_9f-9";
export var textSwitchOption = "_9f-a";
export var textSwitchOptionSelected = "_9f-b";
export var verticalContainer = "_9f-6";
export var xs = "_9f-4";